// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".terms.term-letter[data-v-4afef661]{margin-top:60px}@media (max-width:1199px){.terms.term-letter[data-v-4afef661]{margin-top:0}}.terms__letter-navigation[data-v-4afef661]{margin-bottom:30px}@media (max-width:767px){.terms__letter-navigation[data-v-4afef661]{margin-bottom:10px}}", ""]);
// Exports
module.exports = exports;
